"use strict";

var Shuffle = window.Shuffle;

var ImageGalleryShuffle = function (element) {
  this.vans = Array.from(document.querySelectorAll(".js-vans input"));
  this.images = Array.from(document.querySelectorAll(".js-images input"));

  this.shuffle = new Shuffle(element, {
    easing: "cubic-bezier(0.165, 0.840, 0.440, 1.000)", // easeOutQuart
    sizer: ".the-sizer",
  });

  this.filters = {
    vans: [],
    images: [],
  };

  this._bindEventListeners();
};

/**
 * Bind event listeners for when the filters change.
 */
ImageGalleryShuffle.prototype._bindEventListeners = function () {
  this._onVanChange = this._handleVanChange.bind(this);
  this._onImageChange = this._handleImageChange.bind(this);

  this.vans.forEach(function (input) {
    input.addEventListener("change", this._onVanChange);
  }, this);

  this.images.forEach(function (input) {
    input.addEventListener("change", this._onImageChange);
  }, this);
};

/**
 * Get the values of each checked input.
 * @return {Array.<string>}
 */
ImageGalleryShuffle.prototype._getCurrentVanFilters = function () {
  return this.vans
    .filter(function (input) {
      return input.checked;
    })
    .map(function (input) {
      return input.value;
    });
};

/**
 * Get the values of each checked input.
 * @return {Array.<string>}
 */
ImageGalleryShuffle.prototype._getCurrentImageFilters = function () {
  return this.images
    .filter(function (input) {
      return input.checked;
    })
    .map(function (input) {
      return input.value;
    });
};

/**
 * A Van input check state changed, update the current filters and filte.r
 */
ImageGalleryShuffle.prototype._handleVanChange = function () {
  this.filters.vans = this._getCurrentVanFilters();
  this.filter();
};

/**
 * A Image input check state changed,. Update filters and display.
 */
ImageGalleryShuffle.prototype._handleImageChange = function () {
  this.filters.images = this._getCurrentImageFilters();
  this.filter();
};

/**
 * Filter shuffle based on the current state of filters.
 */
ImageGalleryShuffle.prototype.filter = function () {
  if (this.hasActiveFilters()) {
    this.shuffle.filter(this.itemPassesFilters.bind(this));
  } else {
    this.shuffle.filter(Shuffle.ALL_ITEMS);
  }
};

/**
 * If any of the arrays in the `filters` property have a length of more than zero,
 * that means there is an active filter.
 * @return {boolean}
 */
ImageGalleryShuffle.prototype.hasActiveFilters = function () {
  return Object.keys(this.filters).some(function (key) {
    return this.filters[key].length > 0;
  }, this);
};

/**
 * Determine whether an element passes the current filters.
 * @param {Element} element Element to test.
 * @return {boolean} Whether it satisfies all current filters.
 */
ImageGalleryShuffle.prototype.itemPassesFilters = function (element) {
  var appliedVanFilters = this.filters.vans;
  var appliedImageFilters = this.filters.images; 
  var vanTypes = element.getAttribute("data-van").split('|');
  var imageTypes = element.getAttribute("data-image").split('|');

  /**
   * Check if image contains any one filter.
   * @param {Array} appliedFilters - the active filters
   * @param {Array} filtersOnImage - filters on image
   */
  const isMatchingImage = (appliedFilters, filtersOnImage) => {
    // if there are no filters applied, match all images
    if (appliedFilters.length == 0) {
      return true
    }

    // for each applied filter, see if image contains a matching attribute
    const hasMatch = (appliedFilters || []).filter((filterToApply) => {
      // check if any filters on the image match the filter to apply
      return filtersOnImage?.includes(filterToApply)
    }).length > 0

    return (
      hasMatch
    );
  };

  if (!isMatchingImage(appliedVanFilters, vanTypes)) {
    return false;
  }

  if (!isMatchingImage(appliedImageFilters, imageTypes)) {
    return false;
  }

  return true;
};

document.addEventListener("DOMContentLoaded", function () {
  window.demo = new ImageGalleryShuffle(document.querySelector(".js-shuffle"));
});
